export const environment = {
  production: true,
  appVersion: '1.5.0',
  serviceUrl: 'https://api.getpeech.com',
  gatewayUrl: 'https://peech-gateway-138chblz.uc.gateway.dev',
  amplitudeKey: '2d78c8bf37d5d20955c2234b95b6d4b5',
  clarityProjectId: 'rnqa9hzkd2',
  gtmContainerId: 'GTM-K6TS86L4',
  // Self-hosted GTM: tm.<apex> proxies the container, so the loader is first-party on
  // whichever domain the funnel is served from. gtmLoaderPath is the container's
  // randomized loader path — it replaces gtm.js rather than prefixing it.
  gtmTaggingApexes: ['getpeech.com', 'peech.app'] as string[],
  gtmLoaderPath: 'QlxxeHtG8',
  newsbreakPixelId: 'ID-2096929640815648769',
  axonEventKey: 'd22f8513-3f82-4461-96d7-385a52d2f83d',
  payPalClientId:
    'AUDRyAHhOBpApkRM8LWw9K6KWdgOhz0uRDISEHMagPM5NhjeH1vOP1XGiOHdlueqWVHIhPfucKNMpzQ3',
};
